import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';

/**
 * Compact note under Community Amenities explaining that Heights and Summit
 * residents share access to both communities' amenities.
 */
export function SharedAmenitiesNote() {
  return (
    <section
      className="shared-amenities-note"
      aria-label="Shared community amenities"
    >
      <div className="shared-amenities-note__inner">
        <RichTextContent
          path="sharedamenitiesnote.body"
          label="Shared Amenities Note"
          defaultValue="<p>Residents of The Heights at Rock Hill and The Summit at Rock Hill have access to amenities at both communities.</p>"
          as="div"
          className="shared-amenities-note__body"
        />
      </div>

      <style>{`
        .shared-amenities-note {
          background: var(--vibe-color-background);
          padding: 0 1rem 2.5rem;
        }
        .shared-amenities-note__inner {
          max-width: 42rem;
          margin: 0 auto;
          text-align: center;
        }
        .shared-amenities-note__body {
          font-family: var(--vibe-font-body);
          font-size: 1rem;
          line-height: 1.6;
          color: var(--vibe-color-text);
        }
        .shared-amenities-note__body p {
          margin: 0;
        }
        @media (max-width: 600px) {
          .shared-amenities-note {
            padding: 0 0.75rem 2rem;
          }
          .shared-amenities-note__body {
            font-size: 0.9375rem;
          }
        }
      `}</style>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SharedAmenitiesNote',
  displayName: 'Shared Amenities Note',
  tokens: {
    'sharedamenitiesnote.body': {
      label: 'Shared Amenities Note',
      type: 'richtext',
      defaultValue:
        '<p>Residents of The Heights at Rock Hill and The Summit at Rock Hill have access to amenities at both communities.</p>',
    },
  },
};

(SharedAmenitiesNote as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default SharedAmenitiesNote;
